export default "__VITE_ASSET__C_Tj_sDS__"